import "@babel/polyfill";
import React from "react";
import axios from "axios";
import * as ReactDOM from "react-dom";
import { App } from "./app";
import { reducers } from "./reducers";
import { createReduxStore } from "./libraries/react-bootstrapper";
import "@coverme/styles/main.scss";
import "react-toastify/dist/ReactToastify.css";
import "whatwg-fetch";
import Cookie from "js-cookie";
import LogRocket from "logrocket";

const store = createReduxStore(reducers);

function mergeConfig(config, envConfig) {
    return {
        ...config,
        ...envConfig,
    };
}

if (process.env.NODE_ENV.toLowerCase() === "local") {
    import("../configs/appsettings.local.json")
        .then(envConfig => {
            const config = require("../configs/appsettings.json");
            return mergeConfig(config, envConfig);
        })
        .then(runApplication);
} else {
    fetch("/config")
        .then(response => response.json())
        .then(runApplication);
}

function initializeIntercom(appId) {
    // The intercom guide asks us to put this in the head of the browser. I'm not sure about that. I believe it should live here unless we have a good reason to move it
    var APP_ID = appId;

    window.intercomSettings = {
        app_id: APP_ID,
    };
    (function() {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            var d = document;
            var i = function() {
                i.c(arguments);
            };
            i.q = [];
            i.c = function(args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function() {
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = `https://widget.intercom.io/widget/${appId}`;
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
            };
            if (w.attachEvent) {
                w.attachEvent("onload", l);
                l();
            } else {
                w.addEventListener("load", l, false);
                l();
            }
        }
    })();
}

function initializeUpscope() {
    (function(w, u, d) {
        var i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        var l = function() {
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://code.upscope.io/H68KMRWhsA.js";
            var x = d.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
        };
        if (typeof u !== "function") {
            w.Upscope = i;
            l();
        }
    })(window, window.Upscope, document);

    Upscope("init");
}

function initializeAxios(config) {
    axios.defaults.baseURL = config.apiGatewayUrl;

    axios.defaults.headers = {
        ProductName: "MARKETPLACE",
    };

    let miscHeaders = {};

    if (!!window.MSInputMethodContext && !!document.documentMode) {
        console.warn("WHY ARE YOU USING IE...");
        miscHeaders = {
            ...miscHeaders,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
            "If-Modified-Since": "0",
        };
    }

    axios.interceptors.request.use(config => {
        const customerId = Cookie.get("cc-cus-id");
        return {
            ...config,
            headers: {
                ...config?.headers,
                SelectedCustomerId: customerId,
                ...miscHeaders,
            },
        };
    });
}

function runApplication(config) {
    // exposes the raw file for Paya integration purposes
    // https://docs.payaconnect.com/developers/quick-start/payform-accountform
    require("!!file-loader?name=payform.css!./styles/payform.css");

    initializeAxios(config);
    if (config.isIntercomEnabled) {
        initializeIntercom(config.intercomAppId);
    }

    if (config.isUpscopeEnabled) {
        initializeUpscope();
    }

    if (config.isLogRocketEnabled) {
        LogRocket.init("nrf1l9/coverme-marketplace");
    }

    window.appConfiguration = config;
    ReactDOM.render(<App store={store} config={config} />, document.getElementById("app"));
    if (module.hot) {
        module.hot.accept("./app.jsx", () => {
            ReactDOM.render(<App store={store} config={config} />, document.getElementById("app"));
        });
    }
}
